module.exports = __webpack_public_path__ + "img/130.a5dee93c.jpg";